<script>
import {onMounted, onBeforeUnmount} from "vue";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import CatalogComponent from "@js/components/Sections/Catalog/CatalogComponent.vue";
import {useCatalogStore} from "@js/store/CatalogStore.js";
import {checkDocument} from "@js/helpers.ts";

export default {
    name: "CatalogPage",
    props: {
        catalog_title: String,
    },
    components: {
        CatalogComponent,
        MobileTopBar,
    },
    setup() {
        const catalogStore = useCatalogStore();

        // хендлер сохранения
        const saveScroll = () => {
            if (checkDocument()) {
                catalogStore.setSavedScroll(window.scrollY);
            }
        };

        onMounted(() => {
            if (checkDocument()) {
                // при заходе — если есть сохранённая позиция, скроллим к ней
                if (catalogStore.savedScroll) {
                    window.scrollTo(0, catalogStore.savedScroll);
                }
                // навешиваем слушатель
                window.addEventListener("scroll", saveScroll);
            }
        });

        onBeforeUnmount(() => {
            if (checkDocument()) {
                window.removeEventListener("scroll", saveScroll);
            }
        });
    },
};
</script>

<template>
    <MobileTopBar/>
    <CatalogComponent :catalog_title="catalog_title"/>
</template>
